import { render } from "./EditAccount.vue?vue&type=template&id=43d44a72&scoped=true"
import script from "./EditAccount.vue?vue&type=script&lang=js"
export * from "./EditAccount.vue?vue&type=script&lang=js"

import "./EditAccount.vue?vue&type=style&index=0&id=43d44a72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43d44a72"

export default script